import { ParamsResponse } from 'interfaces/global.types';
import request from './request';

const userService = {
  getAll: (params?: ParamsResponse) => request.get('users/', { params }),
  getID: (id?: number) => request.get(`users/${id}/`),
  delete: (id?: number) => request.delete(`users/${id}/`),
  create: (data?: any) => request.post('users/', data),
  updatePassword: (data?: any) => request.post('auth/user/change_password/', data),
  update: (id?: number, data?: any) => request.patch(`users/${id}/`, data),
};

export default userService;
